module.exports = __webpack_public_path__ + "img/employee-ahmed-omar.8c96deea.jpg";